module.exports = __webpack_public_path__ + "img/inf-banner-mob.1e53bfb6.png";